<template>
  <v-dialog class="modal" v-model="internal" max-width="900">
    <v-card class="px-4 py-0 my-0">
      <v-card-actions class="d-flex justify-space-between align-center">
        <v-card-title class="font-weight-bold">{{ $t('toolbar.settings.title') }}</v-card-title>
        <v-btn @click="closeModal" small icon><v-icon>mdi-close</v-icon></v-btn>
      </v-card-actions>
      <div style="width:100%" class="my-4 py-0 d-flex flex-gap-4">
        <v-card outlined class="flex-grow-1 py-3">
          <div class="mx-5 mt-5 pa-0 px-4"/>
          <v-card-title class="mx-5 py-0 pb-2">{{ $t('settingsModal.defaultLanguage') }}</v-card-title>
          <v-radio-group class="mx-10"  v-model="lang">
            <v-radio v-for="loc in locales" :key="loc.value" :label="loc.label" :value="loc.value"></v-radio>
          </v-radio-group>
        </v-card>
      </div>

      <v-card outlined class="my-5 py-1">
        <v-card-title class="mx-5">{{ $t('settingsModal.defaultApplication') }}</v-card-title>
        <v-row class="grid-modules mt-0">
          <v-col cols="6" md="6" class="grid-col" :key="c.id" v-for="c in coreStore.contentCard">
            <base-badge :change-switch="checkSwitch" :icon="c.icon" :title="c.name"
              :value="isActive(c)" :is-disable="c.disabled || c.locked" :is-locked="c.locked"
              :subtitle="$t(c.descKey)"></base-badge>
          </v-col>
        </v-row>
      </v-card>
      <!-- <v-card outlined class="my-5">
          <v-card-title class="mx-5">{{ $t('settingsModal.launchpadLayout') }}</v-card-title>
          <launchpad-layout/>
      </v-card> -->

    </v-card>
  </v-dialog>
</template>

<script>
import { useCoreStore } from '@/store/coreStore';
import { mapStores } from 'pinia';
import BaseBadge from '../common/BaseBadge.vue';
import LaunchpadLayout from '../layout/LaunchpadLayout.vue';
import { setLocale, AVAILABLE_LOCALES } from '@/i18n/i18n';
export default {
  mounted() {
    let selected = this.coreStore.getSelectedProduct
    this.defaultSelect = selected.value
  },
  components: {
    BaseBadge,
    LaunchpadLayout
  },
  data() {
    return {
      defaultSelect: null,
      locales: AVAILABLE_LOCALES
    };
  },
  props: {
    value: { type: Boolean, default: false },
  },
  watch: {
    internal(val) {
      if (!val) {
      }
    },
    'coreStore.selectedProduct': {
      immediate: true,
      deep: true,
      handler(val) {
        this.defaultSelect = val?.name || ''
      }
    }
  },
  computed: {
    ...mapStores(useCoreStore),
    // Computed, e nao data: este modal fica montado o tempo todo no App.vue,
    // entao um valor copiado no boot ficaria velho depois de uma troca feita em
    // outro lugar (o seletor da tela de login). Ler o locale tambem conserta o
    // radio vazio em navegador novo, onde o localStorage ainda nao tem a chave
    // mas a tela ja esta no default do i18n.
    lang: {
      get() {
        return this.$i18n.locale
      },
      set(val) {
        setLocale(val)
      },
    },
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        //this.$emit("input", v);
      },
    },
  },
  methods: {
    isActive(c) {
      return this.coreStore.selectedProduct?.name === c.name
    },
    checkSwitch(name) {
      const current = this.coreStore.selectedProduct?.name

      if (current === name) {
        this.coreStore.removeSelectedProduct()
        this.$router.push('/home')
        this.closeModal()
        return
      }

      const selected = this.coreStore.contentCard.find(c => c.name === name)
      // Aqui, diferente da /home, o clique no card nao navega: este modal so
      // escolhe o app padrao, e app sem acesso nao pode ser escolhido.
      if (!selected || selected.locked || selected.disabled) return

      // O card guarda a rota em `link` e o saveSelectedProduct le `path`:
      // passar o card cru gravava o favorito com path vazio.
      this.coreStore.saveSelectedProduct({
        name: selected.name,
        path: selected.link,
        value: selected.value,
      })
    },
    closeModal() {
      this.coreStore.handleSettingsModal(false)
      this.$emit("input", false);
    }
  },
};
</script>
<style scoped>
::v-deep .v-dialog {
  scrollbar-width: none;
}

::v-deep .card .v-label {
  font-size: 20px !important;
  font-weight: 600 !important;
}

.grid-modules {
  width: 90%;
  margin: .4rem auto;
}

.grid-col {
  display: flex;
  flex-direction: column;
  gap:0rem;
}
</style>
